import { css, styled } from '@mui/material/styles';
import MuiTextField from '@mui/material/TextField';
export const TextField = styled(MuiTextField)<{ inputerror?: string, inputcolor?:string }>`
    ${({theme, inputerror = '', inputcolor = 'regular'}) => css`
    & label.Mui-focused{
        color: ${theme.palette.grey[600]} !important;
    },
    & .MuiInputLabel-root{
        color: ${theme.palette.grey[400]} !important;
        font-style: normal !important;
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 24px !important;
        letter-spacing: 0.15px !important;
    },
    & .MuiOutlinedInput-input{
        color: ${inputcolor === 'regular' ? theme.palette.grey[800] : inputcolor} !important;
        font-style: normal !important;
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 24px !important;
        letter-spacing: 0.15px !important;
    },
    & .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
        border-color: ${inputerror ? theme.palette.error.main : theme.palette.grey[300]} !important;
        border-radius: 10px;
        border-width: 1.2px !important;


    },
    &:hover .MuiOutlinedInput-root, .MuiOutlinedInput-notchedOutline{
       border-color: ${theme.palette.grey[300]} !important;
       border-width: 1.2px !important;

    },
    & .MuiFormHelperText-root  {
        color: ${theme.palette.error.main};
    },
    & .MuiTextField-root.Mui-error .MuiOutlinedInput-notchedOutline {
            border-color: ${theme.palette.error.main};
        }
  `}
    `;
